<ebs-search [hideInput]= "hideInput" (searchText)="handleSearchText($event)"></ebs-search>

@if (gettingSearchItems) {
  <ebs-spinner [spinnerMessage]="'getting search items'"></ebs-spinner>
}
<div>
  @if (!gettingSearchItems) {
    @for (item of searchItems; track item; let i = $index) {
      <div class="pl-3 pr-3 pb-0 pt-0">
        @if (i === 0) {
          <hr>
          }
          <div class="d-flex flex-row mt-2">
            <div id="index{{i}}" class="click-link header-link">
              <a [routerLink]="[getLink(item.uri)]" [queryParams]="getQueryParams(item.uri)"  (click)="routeFromSearchResult(item.uri, i)"
              [fragment]="getFragment()">{{item.displayTitle}} </a>
            </div>
          </div>
          <div class="d-flex flex-column">
            <div class="text-muted">{{item.summary}}</div>
            <div class=" mt-2 forum-description">
              <span innerHTML="{{item.content | texttruncate: 200}}"> </span>
            </div>
          </div>
          <hr>
          </div>
        }
      }

      @if (loadingMore) {
        <ebs-spinner [spinnerMessage]="'getting more search results'"></ebs-spinner>
      }
      <!-- Load More -->
      @if (searchItems.length > 0) {
        @if (!noItemsReturned && !itemsLessThanItemsPerPage) {
          <div class="row mt-3">
            <div class="col-12 col-sm-6 offset-sm-3 text-center">
              <span (click)="loadMoreSearchItems()" class="btn btn-primary btn-sm">
                <i class="fas fa-arrow-down"></i> Load more
              </span>
            </div>
          </div>
        }
      }
      @if (thereAreNoMore()) {
        <ebs-message-simple [iconCssClasses]="'text-info fa fa-fw fa-exclamation-circle'" [textCssClasses]="'text-info'"
        [displayMessage]="'There are no more search results.'"></ebs-message-simple>
      }
      <p></p>
    </div>